(function() {
'use strict';
  
  angular
    .module('app.viewSync')
    .factory('viewSyncService', viewSyncService);
      
  viewSyncService.$inject = ['$log', '$transitions', '$state', 'marsService'];
    
  function viewSyncService($log, $transitions, $state, marsService) {
    $log = $log.getInstance('viewSyncService');
    
    var enabled = false
      , ignoredStates = []
      , syncInProgress = null;
    
    $transitions.onSuccess({}, _onStateChangeSuccess);
    marsService.on('/user/view-sync', _onUserViewSync);
    
    return {
      disable: disable,
      enable: enable,
      ignoreStates: ignoreStates,
      isEnabled: isEnabled
    };
    
    function disable() {
      enabled = false;
    }
    
    function enable() {
      enabled = true;
    }
    
    function ignoreStates(states) {
      states = angular.isArray(states) ? states : [states]; 
      ignoredStates = _.union(ignoredStates, states);
    }
    
    function isEnabled() {
      return enabled;
    }
    
    function _onStateChangeSuccess(transition) {
      var toStateName = transition.to().name;
      if (!enabled)
        return;
      if (syncInProgress) {
        if (toStateName === syncInProgress.state) {
          syncInProgress = null;
          $log.debug('Synchronization complete');
        }
      }
      else if (!_.contains(ignoredStates, toStateName)) {
        var data = {
          state: toStateName,
          stateParams: transition.params('to')
        };
        $log.debug('Sending view synchronization: ', data);
        marsService.request('/user/view-sync', data);
      }
    }
    
    function _onUserViewSync(event, data) {
      if (!enabled)
        return;
      $log.debug('Received view synchronization: ', data);
      syncInProgress = data;
      $state.go(data.state, data.stateParams);
    }
  }
  
})();